import { Select as RadixSelect } from '@radix-ui/themes'
import type { ComponentPropsWithoutRef } from 'react'
import { forwardRef } from 'react'

type SelectSize = '1' | '2' | '3'
type SelectTriggerVariant = 'classic' | 'surface' | 'soft' | 'ghost'
type SelectContentVariant = 'solid' | 'soft'

type SelectRootProps = ComponentPropsWithoutRef<typeof RadixSelect.Root> & {
  size?: SelectSize
}

type SelectTriggerProps = ComponentPropsWithoutRef<
  typeof RadixSelect.Trigger
> & {
  variant?: SelectTriggerVariant
}

type SelectContentProps = ComponentPropsWithoutRef<
  typeof RadixSelect.Content
> & {
  variant?: SelectContentVariant
}

const SelectRoot = ({ size = '2', ...props }: SelectRootProps) => {
  return <RadixSelect.Root size={size} {...props} />
}

SelectRoot.displayName = 'Select.Root'

const SelectTrigger = forwardRef<HTMLButtonElement, SelectTriggerProps>(
  ({ variant = 'surface', ...props }, ref) => {
    return <RadixSelect.Trigger ref={ref} variant={variant} {...props} />
  }
)

SelectTrigger.displayName = 'Select.Trigger'

const SelectContent = forwardRef<HTMLDivElement, SelectContentProps>(
  ({ variant = 'solid', ...props }, ref) => {
    return <RadixSelect.Content ref={ref} variant={variant} {...props} />
  }
)

SelectContent.displayName = 'Select.Content'

export const Select = {
  Root: SelectRoot,
  Trigger: SelectTrigger,
  Content: SelectContent,
  Item: RadixSelect.Item,
  Group: RadixSelect.Group,
  Label: RadixSelect.Label,
  Separator: RadixSelect.Separator
}
